<template>
    <div class="timeline-empty-overlay">
        <EmptyStateIcon />
    </div>
</template>

<script setup lang="ts">
import EmptyStateIcon from '../../atoms/EmptyStateIcon.vue';

defineOptions({ name: 'TimelineEmptyState' });
</script>

<style scoped>
.timeline-empty-overlay {
    position: absolute;
    /* Position below the header to match Table view vertical alignment */
    top: 80px;
    left: 0;
    right: 0;
    bottom: 0;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    background-color: rgba(255, 255, 255, 0.98);
    min-height: 565px;
    padding: 40px 20px;
}

/* Ensure the empty state icon inherits full container sizing */
.timeline-empty-overlay :deep(.empty-state-container) {
    width: 100%;
    max-width: 100%;
}

.timeline-empty-overlay :deep(.empty-state-image) {
    max-width: 405px;
}
</style>
